import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Radio from '../../../../../../../components/radio';
import UIHelper from '../../../../../../../helpers/UIHelper';
import { Link } from 'react-router-dom';

const InfoSection = ({ contactRoles, managers, singleItem, isNew }) => {
  const { t } = useTranslation();
  console.log('singleItem=');

  const visitCard = singleItem?.allData?.visit_card;

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Nome')} name='name'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Cognome')} name='surname'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Ruolo')} name='leasings_contact_role_id'>
          <Select placeholder={t('Ruolo')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {contactRoles.map((role) => (
              <Select.Option key={role.value} value={role.value}>
                {role.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Nome azienda')} name='company_title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={6} />
      {/* <Col span={9}>
        <Form.Item label={t('Titolo')} name='contact_rank'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col> */}
      <Col span={9}>
        <Form.Item label={t('Data primo incontro')} name='first_visit_date'>
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Mail *')}
          name='email'
          required
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              validator: (_, value) => {
                const trimmed = (value ?? '').toString().trim();
                if (!trimmed) {
                  return Promise.reject(new Error(t('Email obbligatorio')));
                }
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
                  return Promise.reject(new Error(t('Email non valido')));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Cellulare *')} name='cellphone'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Numero ufficio')} name='phone'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      {/* <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Partita IVA')} name='tax_code'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Data primo incontro')} name='first_visit_date'>
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col> */}

      <Col span={6} />
      <Col span={9}>
        <Form.Item
          label={t('Indirizzo azienda *')}
          name='company_address'
          required
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              validator: (_, value) => {
                const trimmed = (value ?? '').toString().trim();
                if (!trimmed) {
                  return Promise.reject(
                    new Error(t('Indirizzo azienda obbligatorio')),
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Leasing manager di riferimento')}
          name='leasings_manager_id'
        >
          <Select
            placeholder={t('Leasing manager di riferimento')}
            {...UIHelper.getSelectSearchProps('title')}
          >
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {managers.map((manager) => (
              <Select.Option key={manager.value} value={manager.value}>
                {manager.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Stato contatto')} name='status'>
          <Radio.Group>
            <Radio value={'active'}>{t('Attiva')}</Radio>
            <Radio value={'inactive'}>{t('Disattiva')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col span={6} />
      {/* <Col span={9}>
        <Form.Item label={t('Numero unità proposte')} name='rooms_proposet'>
          <Input
            disabled={true}
            type={'number'}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Data ultimo contatto')}
          name='lasttime_contact_date'
        >
          <DatePicker
            disabled={true}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col> */}

      <Col span={6} />
      {!isNew && visitCard?.id && (
        <Col span={9}>
          <Link to={`/leasing/visit_card/${visitCard?.id}/edit`}>
            {t('Riferimento ultimo contatto')}
          </Link>
          {/*<Form.Item*/}
          {/*  label={t('Riferimento ultimo contatto')}*/}
          {/*  name='last_visit_link'*/}
          {/*>*/}
          {/*  <Input*/}
          {/*    disabled={true}*/}
          {/*    type={'number'}*/}
          {/*    placeholder={t('Inserisci testo')}*/}
          {/*  />*/}
          {/*</Form.Item>*/}
        </Col>
      )}
    </Row>
  );
};

export default React.memo(InfoSection);
